// extracted by mini-css-extract-plugin
module.exports = {"root":"full-width-image-module--root--3mEh3","root__image":"full-width-image-module--root__image--1Vnav"};